export function apiBaseUrlFactory(): string {
  if (window.location.origin.includes('localhost:4200')) {
    return 'https://localhost:26741';
  }

  return 'https://api.' + window.location.hostname;
}
